import { useMutation, useQuery } from 'react-query';
import { httpRequest } from '../config/api';

const service = {
  getList: (sheetId, params) =>
    httpRequest.get(`api/extra-prompts/${sheetId}`, {
      params
    }),
  create: (data, params) =>
    httpRequest.post('api/extra-prompts/', data, {
      params
    }),
  update: (data, params) =>
    httpRequest.put(`api/extra-prompts/${data.id}`, data.data, {
      params
    }),
  delete: data => httpRequest.delete(`api/extra-prompts/${data.id}`)
};

export const useGetExtraPrompts = ({ queryOptions, params, sheetId } = {}) => {
  return useQuery(
    ['GET_EXTRA_PROMPTS', params, sheetId],
    () => service.getList(sheetId, params),
    queryOptions
  );
};

export const useCreatePrompt = ({ params }) => {
  return useMutation(data => service.create(data, params));
};

export const useUpdatePrompt = ({ params }) => {
  return useMutation(data => service.update(data, params));
};

export const useDeletePrompt = () => {
  return useMutation(service.delete);
};
